export function EventAvailableIcon(): JSX.Element {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path opacity="0.3" d="M5 5.5H19V7.5H5V5.5Z" />
      <path d="M19 3.5H18V1.5H16V3.5H8V1.5H6V3.5H5C3.9 3.5 3 4.4 3 5.5V19.5C3 20.6 3.9 21.5 5 21.5H19C20.1 21.5 21 20.6 21 19.5V5.5C21 4.4 20.1 3.5 19 3.5ZM19 19.5H5V9.5H19V19.5ZM19 7.5H5V5.5H19V7.5ZM16.49 12.03L15.43 10.97L10.56 15.84L8.45 13.73L7.39 14.79L10.56 17.96L16.49 12.03Z" />
    </svg>
  );
}
